import { styled as o } from "styled-components";
import { CommentOptions as t } from "../../../CommentOptions/index.js";
import { CommentTimestamp as e } from "../../../CommentTimestamp/index.js";
import { Small as n } from "../../../../../../styles/typography/index.js";
import { Colors as r } from "../../../../../../styles/colors/index.js";
const x = o.header`
  display: flex;
  justify-content: space-between;
`, c = o(t)`
  margin-bottom: 0px;
`, d = o(e)`
  margin: 4px 0px 0px 8px;
`, f = o.span`
  ${n}
  color: rgb(${r.Gray});
  margin: 4px 0px 0px 8px;
`;
o.div`
  cursor: pointer;
`;
const l = o.div`
  display: flex;
  flex-direction: row;
`;
export {
  c as CommentOptionsOnContent,
  f as EditedText,
  x as HeaderContainer,
  l as LeftContent,
  d as Timestamp
};
